import React from "react";
import { stories } from "../data";

export default function SuccessStories() {
  return (
    <section className="mu-section-stories" id="about">
      <div className="container">
        <div className="section-head-row">
          <div>
            <div className="mu-eyebrow on-purple">Proof</div>
            <h2 className="section-title">Success Stories</h2>
            <p className="section-sub">
              Hear from artists and partners who have grown their audience and expanded their
              reach with MusicUntamed.
            </p>
          </div>
          <a href="#about" className="btn-mu-outline-light">Read More Stories &rarr;</a>
        </div>

        <div className="row g-4">
          {stories.map((s, i) => (
            <div className="col-md-4" key={i}>
              <div className="quote-card">
                <div className="quote-mark">&ldquo;</div>
                <p className="quote-text">"{s.text}"</p>
                <div className="quote-source">— {s.source}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
